import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { ActivatedRoute, provideActivatedRoute } from '@tmf-shared-platform/activated-route/activated-route';
import { distinctUntilChanged, map, type Observable } from 'rxjs';

export class BcfActivatedModalAdapter {
  constructor(private _activatedRoute: ActivatedRoute) {}

  private _extractModalFragment(fragment: string | undefined): string | undefined {
    if (!fragment) {
      return undefined;
    }
    return fragment.startsWith('modal-') ? fragment.replace('modal-', '') : fragment;
  }

  public get modal$(): Observable<string | undefined> {
    return this._activatedRoute.fragment$.pipe(
      map((fragment: string | undefined) => this._extractModalFragment(fragment)),
      map((modalNameWithParams: string | undefined) => modalNameWithParams?.split('$')[0]),
      distinctUntilChanged()
    );
  }

  public get param(): Observable<string | undefined> {
    return this._activatedRoute.fragment$.pipe(
      map((fragment: string | undefined) => this._extractModalFragment(fragment)?.split('$')?.[1] ?? undefined),
      distinctUntilChanged()
    );
  }

  public get params(): Observable<string[] | undefined> {
    return this.param.pipe(
      map((param: string | undefined) => param?.split('~')),
      distinctUntilChanged()
    );
  }
}

export function provideBcfActivatedModalAdapter(): BcfActivatedModalAdapter {
  return provideSingleton(BcfActivatedModalAdapter, () => new BcfActivatedModalAdapter(provideActivatedRoute()));
}
